import { CSpinner } from '@coreui/react-pro'
import React from 'react'
import './Loader.scss'
const Loader = (props) => {
  return (
    <div className="fullscreen-loader">
      <CSpinner
        className={`center-loader ${props?.className ? props.className : ''}`}
        color={props?.color || 'dark'}
      />
    </div>
  )
}

export default Loader

//color - "dark" ｜ "light" ｜ "info" ｜ "warning" ｜ "primary" ｜ "secondary" ｜ "success"  | "danger"
